import { PERMISSIONS } from '../auth/permissions/catalog';
import { CAMPAIGN_MANAGE_ROLES } from '../campaigns/domain/campaignRoles';

/**
 * Access rules of the Subagents module, in one place.
 *
 * The PRD (decision 3-sep-2026) gives Subagents exactly the permissions of
 * Campaigns — "whoever can access Campaigns can see and edit Subagents", no
 * matrix of its own — so both values are Campaigns' own rather than new ones:
 *
 * - `view`: the agent permission the `campaigns` route uses. There is no atomic
 *   `campaigns.*` (nor `subagents.*`) permission in the catalogue yet; see the
 *   TODO(perms) next to the `campaigns` route in `router/AppRouter.tsx`. When it
 *   exists, this line is the only edit.
 * - `manageRoles`: who may create (and, with VOX-330, edit and delete). The same
 *   list as Campaigns, which is also the Assistant backend's write roles for
 *   `/{chatbotId}/subagents` (VOX-293: every read role but OPERATOR).
 */
export const SUBAGENTS_PERMISSIONS = {
  view: PERMISSIONS.agent.view,
  manageRoles: CAMPAIGN_MANAGE_ROLES,
} as const;

export type SubagentsManageRole = (typeof SUBAGENTS_PERMISSIONS.manageRoles)[number];

/** Whether this role may create subagents. */
export function canManageSubagents(role: string | null | undefined): boolean {
  return (SUBAGENTS_PERMISSIONS.manageRoles as readonly string[]).includes(role ?? '');
}
